var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    typography = _ref.typography;
  return {
    checkboxWrapperPadding: spacing.xSmall,
    stimulusTitleBottomPadding: spacing.medium,
    stimulusTitleFontSize: typography.fontSizeLarge,
    radioSpaceBottomPadding: spacing.xSmall
  };
};
export default generateComponentTheme;